import { DragEvent, useState } from 'react';
import styles from '../AvatarInput.module.scss';

interface DropZoneProps {
  onFileSelect: (file: File) => void;
  onClick: () => void;
}

export function DropZone(props: DropZoneProps) {
  const { onFileSelect, onClick } = props;
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    const file = e.dataTransfer.files?.[0];
    if (file) {
      onFileSelect(file);
    }
  };

  return (
    <div
      className={`${styles.dropZone} ${isDragging ? styles.dropZoneDragging : ''}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={onClick}
    >
      <div className={styles.dropZoneContent}>
        <span className={styles.dropZoneIcon} role="img" aria-label="Camera">📷</span>
        <span className={styles.dropZoneText}>
          Drag & drop an image here
        </span>
        <span className={styles.dropZoneSubtext}>
          or click to select
        </span>
        <span className={styles.dropZoneSubtext}>
          PNG or JPEG, min 300×300px
        </span>
      </div>
    </div>
  );
}
